import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig';

export const cMcustomerServicesApi = createApi({
  reducerPath: 'cMcustomerServicesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'Customers',
  ],
  endpoints: builder => ({
    getCustomerServices: builder.query({
      query: (params) => ({
        url: `/customers/customer-services/`,
        params,
      }),
      providesTags: ['Customers']
    }),

    addCustomerService: builder.mutation({
      query: body => ({
        url: '/customers/customer-services/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Customers']
    }),

    getCustomerServiceById: builder.query({
      query: ({id}) => ({
        url: `/customers/customer-services/${id}/`
      }),
      providesTags: ['Customers']
    }),

    updateCustomerService: builder.mutation({
      query: ({ id, body }) => ({
        url: `/customers/customer-services/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Customers']
    }),

    deleteCustomerService: builder.mutation({
      query: id => ({
        url: `/customers/customer-services/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Customers']
    }),

    
  })
})

export const {
  useGetCustomerServicesQuery,
  useAddCustomerServiceMutation,
  useGetCustomerServiceByIdQuery,
  useUpdateCustomerServiceMutation,
  useDeleteCustomerServiceMutation,
} = cMcustomerServicesApi
